import './PlaceholderScreen.css';

export interface PlaceholderScreenProps {
  eyebrow: string;
  line: string;
  soft?: string;
}

// A calm-voice empty state — content, not instruction. No "tap + to add"
// hint anywhere (locked hard rule: the only thing ever taught is the Knot,
// and that's a one-time onboarding concern, never an on-screen caption).
export function PlaceholderScreen({ eyebrow, line, soft }: PlaceholderScreenProps) {
  return (
    <div class="placeholder-screen">
      <div class="placeholder-screen__eyebrow">{eyebrow}</div>
      <div class="placeholder-screen__say">
        {line}
        {soft ? (
          <>
            <br />
            <span class="placeholder-screen__soft">{soft}</span>
          </>
        ) : null}
      </div>
    </div>
  );
}
